export default "__VITE_ASSET__B54Mz_Za__"